import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpXsrfTokenExtractor } from '@angular/common/http';
import {  Observable } from 'rxjs';

@Injectable()
export class CsrfInterceptorInterceptor implements HttpInterceptor {

  static csrfToken: string|undefined = "";

  constructor( private tokenExtractor: HttpXsrfTokenExtractor ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const xsrfHeader = 'X-XSRF-TOKEN';
    if (!['GET','HEAD','OPTIONS'].includes(request.method)) {
      if (!CsrfInterceptorInterceptor.csrfToken) {
        CsrfInterceptorInterceptor.csrfToken = this.tokenExtractor.getToken() as string;
      }
      if (CsrfInterceptorInterceptor.csrfToken != null) {
        request = request.clone({ headers: request.headers.set(xsrfHeader, CsrfInterceptorInterceptor.csrfToken) });
      }
    }
    return next.handle(request);
  }
}
